import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export type HelperTextProps = {
  disabled?: boolean;
  hasError?: boolean;
};

const helperTextBase = css`
  display: inline-block;
  font-size: ${theme.fontSize(12)};
  line-height: 1.33;
  padding-top: ${theme.spacing(1)};
  white-space: normal;
`;

const helperTextDefaultColor = css`
  color: ${theme.colors.neutral50};
`;

const helperTextDisabledColor = css`
  color: ${theme.colors.neutral20};
`;

const helperTextHasErrorColor = css`
  color: ${theme.colors.status.critical};
`;

export const getHelperTextClassName = ({ disabled, hasError }: HelperTextProps) =>
  cx(helperTextBase, disabled ? helperTextDisabledColor : hasError ? helperTextHasErrorColor : helperTextDefaultColor);

export const HelperTextStyles = {
  helperText: getHelperTextClassName,
};
